import Vue from "vue";
import VueWorker from "vue-worker";
Vue.use(VueWorker);
export const risks = {
  data() {
    return {};
  },
  mounted() {},
  watch: {
    "substrate.k"() {
      if (this.installations) {
        for (let installation of this.installations) {
          if (installation.mapObjects) {
            for (let mapObject of installation.mapObjects) {
              if (mapObject.pipelines) {
                for (let pipeline of mapObject.pipelines) {
                  if (pipeline.autoL == 1) {
                    pipeline.L = this.getPipelineLength(pipeline.dots, this.substrate.k);
                  }
                }
              }
            }
          }
        }
      }
      if (this.pipelines) {
        for (let pipeline of this.pipelines) {
          if (pipeline.autoL == 1) {
            pipeline.L = this.getPipelineLength(pipeline.dots, this.substrate.k);
          }
        }
      }
      if (this.dikings) {
        for (let diking of this.dikings) {
          if (diking.autoS == 1 && this.substrate.k) {
            diking.S = this.getDikinsS(diking.dots, this.substrate.k);
            this.$http
              .post("risk/dikings/diking-update?id=" + diking.diking_id, {
                S: diking.S,
              })
              .then(() => {})
              .catch((e) => {
                console.error(e);
              });
          }
        }
      }
      if (this.loading) {
        return;
      }
      this.$emit("update:oldData", true);
    },
    residential: {
      handler: function () {
        if (this.loading) {
          return;
        }
        this.$emit("update:oldData", true);
      },
      deep: true,
    },
    firewalls: {
      handler: function () {
        if (this.loading) {
          return;
        }
        this.$emit("update:oldData", true);
      },
      deep: true,
    },
    solids: {
      handler: function () {
        if (this.loading) {
          return;
        }
        this.$emit("update:oldData", true);
      },
      deep: true,
    },
    dikings: {
      handler: function () {
        if (this.loading) {
          return;
        }
        this.$emit("update:oldData", true);
      },
      deep: true,
    },
    pipelines: {
      handler: function () {
        if (this.loading) {
          return;
        }
        this.$emit("update:oldData", true);
      },
      deep: true,
    },
  },
  methods: {},
};
